export default __webpack_public_path__ + "static/media/planet-venus-internal.1a94aa02.svg";